import {Component, EventEmitter, Inject, Input, OnInit, Output} from '@angular/core';
import {Newsletter} from "../../../shared/interface/newsletter";
import {Observable, ReplaySubject} from "rxjs";
import {AuthService} from "../../../shared/services/auth.service";
import {NewsletterService} from "../../../shared/services/newsletter.service";
import {UserPermissions} from "../../../shared/interface/user-permissions";
import {takeUntil} from "rxjs/operators";
import {Template} from "../../../shared/interface/template";
import {ConfirmDialogComponent} from "../../../shared/components/confirm-dialog/confirm-dialog.component";
import {HttpErrorResponse} from "@angular/common/http";
import {MatDialog} from "@angular/material/dialog";
import {MatSnackBar} from "@angular/material/snack-bar";
import {Router} from "@angular/router";


export interface NewsletterSelectDialogData {
  newsletterObject: Newsletter;
}

@Component({
  selector: 'app-newsletter-details-view',
  templateUrl: './newsletter-details-view.component.html',
  styleUrls: ['./newsletter-details-view.component.scss']
})
export class NewsletterDetailsViewComponent implements OnInit {
  @Input() newsletter: Observable<Newsletter>;
  @Output() modifyClicked = new EventEmitter<any>();

  zoom  = 'page-fit';
  newsletterObject: Newsletter;
  userPermissions: ReplaySubject<UserPermissions>;

  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  constructor(
    private newsletterService: NewsletterService,
    private auth: AuthService,
    private dialog: MatDialog,
    private snack: MatSnackBar,
    private router: Router,
  ) {
    this.userPermissions = auth.getUserPermissions();
  }
  ngOnInit(): void {
    this.newsletter
      .pipe(takeUntil(this.destroyed$))
      .subscribe((newsletter: Newsletter) => this.newsletterObject = newsletter);
  }
  modify(): void {
    this.modifyClicked.emit();
  }

  download(): void {
    this.newsletterService.downloadFile(this.newsletterObject.uuid);
  }
  deleteNewsletter(): void{
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '500px',
      data: {text: 'Czy na pewno chcesz usunąć newsletter?'},
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.newsletterService.deleteNewsletter(this.newsletterObject.uuid)
          .subscribe(() => {
            this.snack.open('Pomyślnie usunięto newsletter', '', {duration: 2000});
              this.router.navigate(['/newsletter/historia']);
          }, (error: HttpErrorResponse) => {
            this.snack.open('Podczas usuwania pliku wystąpił błąd', error.status.toString(), {
              duration: 2000,
            });

            if (error.status === 400) {
              this.snack.open(error.error.error.text, null, {duration: 4000});
            }
          });
      }
    });
  }


}
